import React from "react";
import PreviewPopoverLink from "../PreviewPopover/PreviewPopoverLink";
import DateHelper from "../DateHelper/DateHelper";
import CalendarIcons from '../CalendarIcons/CalendarIcons';
import { differenceInDays } from 'date-fns';

class PropertyCalendarReservationSegment extends React.Component {

	constructor(props) {
		super(props);
	}

	render() {
		var iconCount = 0
		if (this.props.view_mode == "weekly" && this.props.reservation_segment.note_count > 0 && this.props.show_notes) {
			iconCount += 1
		}
		if (this.props.view_mode == "weekly" && this.props.reservation_segment.system_notification_count > 0 && this.props.show_notifications) {
			iconCount += 1
		}
		if (this.props.view_mode == "weekly" && this.props.reservation_segment.service_log_count > 0 && this.props.show_service_logs) {
			iconCount += 1
		}
		if (this.props.view_mode == "weekly" && this.props.reservation_segment.housekeeping_count > 0 && this.props.show_housekeeping) {
			iconCount += 1
		}

		var style = { top: this.props.top + 'px', left: this.props.left + 'px', width: this.props.width + 'px', backgroundColor: this.color()};
		
		const content = (
			<>
				{this.props.isBefore ? null : <span className={this.props.room_type && this.props.room_type.type_of_booking == "daily" ? "leftArrow" : "leftTail"}>&nbsp;</span>}
				{!this.props.isHousekeeping ? (
					this.props.width <= 100 ? 
						<span className="text" style={{ right: '-6px' }}>{this.props.width >= 35 ? this.initials(this.props.reservation_segment.customer ? this.props.reservation_segment.customer.full_name : 'Held') : ''}</span> 
						: 
						<span className="text" style={{ right: this.props.width <= 125 || this.props.room_type && this.props.room_type.type_of_booking == 'daily' ? '-2px' : '-12px' }}>{this.props.reservation_segment.customer ? this.props.reservation_segment.customer.full_name : 'Held'}</span>
				) : (
					<span className="text" style={{ right: '-6px' }}>{I18n.t(this.props.reservation_segment.status)}</span>
				)}
				{this.props.view_mode == "weekly" ? <CalendarIcons {...this.props} color='#fff'/> : null}
				{iconCount > 0 ? <div style={{ clear: 'both', width: `${15 * iconCount}px` }} /> : null}
				{this.props.isAfter ? null : <span className="rightArrow" style={{ borderLeftColor: this.color() }}>&nbsp;</span>}
			</>
		);

		if (this.props.isHousekeeping) {
			return (
				<div className={"PropertyCalendarReservationSegment " + (this.props.isAfter ? 'isAfter ' : '') + (this.props.isBefore ? 'isBefore ' : '')} style={style}>
					{content}
				</div>
			);
		}

		return (
			<PreviewPopoverLink className={"PropertyCalendarReservationSegment " + (this.props.isAfter ? 'isAfter ' : '') + (this.props.isBefore ? 'isBefore ' : '')} style={style} model_type="reservation_segment" model_id={this.props.reservation_segment.id} popoverBodyWidth={300} placement={this.props.top > 140 ? "top" : "bottom"} date_format={this.props.date_format} time_format={this.props.time_format} reservation_segment={this.props.reservation_segment} calendarIcons={true} show_notes={this.props.show_notes} show_notifications={this.props.show_notifications} show_housekeeping={this.props.show_housekeeping} show_service_logs={this.props.show_service_logs}>
				{content}
			</PreviewPopoverLink>
		);
	}

	/**
	* Helper functions
	*/

	color() {
		if (this.props.reservation_segment.status == 'held') {
			return '#4e4e4e'; //dark_gray
		} else if (this.props.reservation_segment.status == 'active') {
			return '#336699'; //blue
		} else if (this.props.reservation_segment.status == 'checked_in') {
			return '#149e35'; // green
		} else if (this.props.reservation_segment.status == 'checked_out') {
			return '#999999'; // gray
		} else if (this.props.reservation_segment.status == 'no_show') {
			return '#c60000'; // red
		} else {
			return '#336699'; // blue
		}
	}

	duration() {
		var start_date = DateHelper.parseDateFromBackend(this.props.reservation_segment.check_in_date);
		var end_date = DateHelper.parseDateFromBackend(this.props.reservation_segment.check_out_date);

		return differenceInDays(end_date, start_date);
	}

	initials(name) {
		var initials = name.match(/\b\w/g) || [];
		initials = ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
		return initials;
	}

}

export default PropertyCalendarReservationSegment